import { UserActionTypes } from "./user-types";

const INITIAL_STATE = {
    user: null,
    userID: -1,
    loggedIn: false,
    checkedLoggedIn: false,
    userDepartment: 'none',
    token: ''
};

const userReducer = (state = INITIAL_STATE, action) => {  //if state is not set, it will fallback and leverage the value set in INITIAL_STATE

    switch(action.type) {
        case UserActionTypes.SET_CURRENT_USER:
            return {
                ...state, //spread in the state but change only the values that we want to modify
                user: action.payload,
                userID: action.payload.profile.userID,
                loggedIn: true,
                checkedLoggedIn: true,
                token: action.payload.token,
            }

        case UserActionTypes.REMOVE_USER:
            return INITIAL_STATE;

        default: //if the action types dont match, we want to return the state.
            return state;
    }
}

export default userReducer;